import React, { useContext } from 'react'
import { AppContext } from './Context/AppContext'

function Header() {
  const { referralId } = useContext(AppContext);
  return (
    <header className="header pb-5">
      <div className="container">
        <div className="row header-row">
          <div className="col-md-50">
            <div className="logo-align">
              <a href="https://touchbroking.com" target="_blank" rel="noreferrer">
                <img src={process.env.PUBLIC_URL +"/img/acumen-logo.png"} alt="Acumen Capital Market" />
              </a>
            </div>
          </div>
          <div className="col-md-50 header-right">
            {referralId && (
              <span className="referral-text">
                <span className="referral-text-label">Referral ID: </span>
                {referralId}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
